import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import { css } from "styled-components"
import PathDivider from "./PathDivider"
import PathLesson from "./PathLesson"

const Path = ({
  items,
  getStepLinkProps,
  renderStepChevron,
  inverted,
  expandedLessonsIds = [],
  // If true, only the Lesson show/hide toggle button will be used to expand/collapse the lesson.
  // Otherwise, the entire Lesson component will be clickable to expand/collapse the lesson.
  discreetToggleOnly = false
}) => {
  return (
    <WithCSS
      as={View}
      className="LegacyPathView"
      css={css`
        position: relative;
        padding: 5px;
        width: 100%;
      `}
    >
      {items.map((item, index) => {
        const { id, type } = item
        if (type === "lesson") {
          return (
            <PathLesson
              key={id}
              lesson={item}
              getStepLinkProps={getStepLinkProps}
              renderStepChevron={renderStepChevron}
              discreetToggleOnly={discreetToggleOnly}
              initialExpand={
                expandedLessonsIds?.length > 0
                  ? expandedLessonsIds.includes(id)
                  : index === 0
              }
            />
          )
        } else if (type === "divider") {
          return <PathDivider key={id} divider={item} inverted={inverted} />
        } else {
          return null
        }
      })}
    </WithCSS>
  )
}

Path.displayName = "Path"

export default Path
